import React from 'react';
import flatten from 'lodash/flatten';
import { compose, withProps, withState } from 'recompose';
import styled, { StylesProps } from '../../../lib/styles';
import navigationPanelStyles from './NavigationBlock_styles';
import { MenuLink } from '../../../models/menu';
import Spacer from '../../../components/presentational/Spacer';
import Icon from '../../../components/presentational/Icon';
import Typography from '../../../components/presentational/Typography';

export interface NavigationBlockProps {
  title: string;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => any;
  breadcrumbs?: MenuLink[];
  links?: MenuLink[];
  childLinks: MenuLink[];
  subtitle?: string;
}

const NavigationBlock = ({
  title,
  subtitle,
  collapsed,
  setCollapsed,
  links = [],
  childLinks,
  breadcrumbs = [],
  styles,
}: NavigationBlockProps & StylesProps<typeof navigationPanelStyles>) => (
  <Typography>
    <div className={`${styles.topContainer} NavigationBlock`}>
      <Spacer width={1160} space={'xxxs'}>
        {breadcrumbs.length > 0 && (
          <Spacer row space={'xxxs'} className={styles.breadcrumbs}>
            {breadcrumbs.map(({ title, href }: MenuLink, i: number) => (
              <Spacer key={title} row space={'xxxs'}>
                <a href={href} title={title}>
                  {title}
                </a>

                {(breadcrumbs.length === 1 || i + 1 != breadcrumbs.length) && (
                  <span className={styles.breadcrumbSep}>&gt;</span>
                )}
              </Spacer>
            ))}
          </Spacer>
        )}

        <h1 className={styles.title}>{title}</h1>

        {subtitle && (
          <div 
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}

      </Spacer>
    </div>

    {links.length > 0 && (
      <div className={styles.bottomContainer}>
        <Spacer width={1160}>
          <div
            className={styles.toggle}
            onClick={() => setCollapsed(!collapsed)}
          >
            <Spacer row justify={'space-between'}>
              <a className={styles.link}>More in {title}</a>

              <Icon icon={'expand_more'} size={'xl'} color={'black'} />
            </Spacer>
          </div>

          <div className={styles.links}>
            {links.map(({ href, title }: MenuLink, i: number) => (
              <a key={i} href={href} title={title} className={styles.link}>
                <div
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </a>
            ))}
          </div>

          {childLinks.length > 0 && (
            <div className={styles.childLinks}>
              {childLinks.map(({ href, title }: MenuLink, i: number) => (
                <a
                  key={i}
                  href={href}
                  title={title}
                  className={styles.childLink}
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                </a>
              ))}
            </div>
          )}
        </Spacer>
      </div>
    )}
  </Typography>
);

export default compose(
  withState('collapsed', 'setCollapsed', true),
  withProps(({ links = [] }) => ({
    childLinks: flatten(links.map(({ links = [] }: MenuLink) => links)),
  })),
  styled(navigationPanelStyles)
)(NavigationBlock);
